import { useState } from 'react';
import { getBlockings as blockingsService } from '@services/blocking-service';

const useBlockings = () => {
  const [blockings, setBlockings] = useState([]);
  const [blockingDetails, setBlockingDetails] = useState([]);

  const getBlockings = async () => {
    await blockingsService().then((resp) => {
      setBlockings(resp.blockings);
      setBlockingDetails(resp.details);
    });
  };

  return {
    getBlockings,
    blockings,
    blockingDetails,
  };
};

export default useBlockings;
